// removed by extract-text-webpack-plugin
module.exports = {"HiddenNavBar":"HiddenNavBar-module__HiddenNavBar__39LOR","LogoWrapper":"HiddenNavBar-module__LogoWrapper__2Z_as","LanguageSwitch":"HiddenNavBar-module__LanguageSwitch__2zhZK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexMain/HiddenNavBar/HiddenNavBar.module.css
// module id = 1769
// module chunks = 31